import { AfterViewInit, Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, ViewChild } from '@angular/core';
import { CdkDragDrop, CdkDropList, DragDropModule, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { MatTableModule } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { TegelModule } from '@scania/tegel-angular-17';
import {MatTabsModule} from '@angular/material/tabs';

@Component({
    selector: 'app-summary',
    templateUrl: './summary.component.html',
    styleUrls: ['./summary.component.scss'],
    imports: [
      CommonModule,
      DragDropModule,
      MatTableModule,
      MatTabsModule,
      TegelModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SummaryComponent implements AfterViewInit {

  @ViewChild(ModalComponent) modalComponent!: ModalComponent;

  @ViewChild('safetyDropList') safetyListRef!: CdkDropList;
  @ViewChild('qualityDropList') qualityListRef!: CdkDropList;
  @ViewChild('assemblyDropList') assemblyListRef!: CdkDropList;
  @ViewChild('logisticsDropList') logisticsListRef!: CdkDropList;
  @ViewChild('projectDropList') projectListRef!: CdkDropList;
  @ViewChild('spctDropList') spctListRef!: CdkDropList;
  @ViewChild('generalDropList') generalListRef!: CdkDropList;

  displayedColumns: string[] = ['name', 'assignedBy', 'openDate', 'targetDate', 'responsible'];

  safetyList = [
    {
      name: 'Fire Extinguisher Inspection',
      assignedBy: 'Lucas Mendes',
      openDate: '2025-04-01',
      targetDate: '2025-04-10',
      responsible: 'Eliabel Souza'
    },
    {
      name: 'Emergency Exit Review',
      assignedBy: 'Pedro Sant Ana',
      openDate: '2025-04-03',
      targetDate: '2025-04-12',
      responsible: 'Marina Lima'
    },
    {
      name: 'Workplace Safety Training',
      assignedBy: 'Carlos Pereira',
      openDate: '2025-04-05',
      targetDate: '2025-04-15',
      responsible: 'Felipe Martins'
    },
    {
      name: 'Hazard Assessment Update',
      assignedBy: 'Bruna Lopes',
      openDate: '2025-04-06',
      targetDate: '2025-04-16',
      responsible: 'Larissa Machado'
    },
    {
      name: 'PPE Equipment Audit',
      assignedBy: 'Renato Silva',
      openDate: '2025-04-08',
      targetDate: '2025-04-18',
      responsible: 'Juliana Campos'
    }
  ];

  qualityList = [
    {
      name: 'Audit Final Assembly Line',
      assignedBy: 'Amanda Torres',
      openDate: '2025-04-02',
      targetDate: '2025-04-14',
      responsible: 'Patrícia Souza'
    },
    {
      name: 'Parts Quality Check',
      assignedBy: 'Renato Silva',
      openDate: '2025-04-04',
      targetDate: '2025-04-16',
      responsible: 'João Costa'
    },
    {
      name: 'Supplier Evaluation',
      assignedBy: 'Beatriz Rocha',
      openDate: '2025-04-07',
      targetDate: '2025-04-20',
      responsible: 'Lucas Ribeiro'
    },
    {
      name: 'Defect Rate Analysis',
      assignedBy: 'Camila Almeida',
      openDate: '2025-04-09',
      targetDate: '2025-04-22',
      responsible: 'Daniela Ferreira'
    },
    {
      name: 'Incoming Materials Inspection',
      assignedBy: 'Marcela Duarte',
      openDate: '2025-04-10',
      targetDate: '2025-04-24',
      responsible: 'Eduardo Moura'
    }
  ];

  assemblyList = [
    {
      name: 'Assemble Engine Components',
      assignedBy: 'Marcos Lima',
      openDate: '2025-04-01',
      targetDate: '2025-04-12',
      responsible: 'Daniela Ferreira'
    },
    {
      name: 'Cabin Installation Review',
      assignedBy: 'Clara Menezes',
      openDate: '2025-04-05',
      targetDate: '2025-04-17',
      responsible: 'Eduardo Moura'
    },
    {
      name: 'Chassis Assembly Audit',
      assignedBy: 'Paulo Barros',
      openDate: '2025-04-06',
      targetDate: '2025-04-18',
      responsible: 'Fernanda Alves'
    },
    {
      name: 'Torque Specification Check',
      assignedBy: 'Rogério Matos',
      openDate: '2025-04-08',
      targetDate: '2025-04-20',
      responsible: 'Marcelo Teixeira'
    },
    {
      name: 'Structural Integrity Test',
      assignedBy: 'Aline Cunha',
      openDate: '2025-04-10',
      targetDate: '2025-04-22',
      responsible: 'Leonardo Borges'
    }
  ];

  logisticsList = [
    {
      name: 'Inbound Shipment Check',
      assignedBy: 'Carla Nunes',
      openDate: '2025-04-02',
      targetDate: '2025-04-14',
      responsible: 'Igor Santos'
    },
    {
      name: 'Warehouse Stock Audit',
      assignedBy: 'Fábio Araújo',
      openDate: '2025-04-06',
      targetDate: '2025-04-18',
      responsible: 'Juliana Campos'
    },
    {
      name: 'Outbound Logistics Planning',
      assignedBy: 'Renata Figueiredo',
      openDate: '2025-04-07',
      targetDate: '2025-04-19',
      responsible: 'Thiago Souza'
    },
    {
      name: 'Customs Clearance Coordination',
      assignedBy: 'Gustavo Andrade',
      openDate: '2025-04-09',
      targetDate: '2025-04-21',
      responsible: 'Larissa Machado'
    },
    {
      name: 'Logistics KPI Review',
      assignedBy: 'Adriana Gomes',
      openDate: '2025-04-10',
      targetDate: '2025-04-22',
      responsible: 'Bruno Pires'
    }
  ];

  projectList = [
    {
      name: 'New Model Development',
      assignedBy: 'Leonardo Borges',
      openDate: '2025-04-03',
      targetDate: '2025-05-01',
      responsible: 'Aline Cunha'
    },
    {
      name: 'Prototype Testing',
      assignedBy: 'Marcela Duarte',
      openDate: '2025-04-08',
      targetDate: '2025-05-05',
      responsible: 'Rafael Barbosa'
    },
    {
      name: 'Software Integration',
      assignedBy: 'Rogério Matos',
      openDate: '2025-04-10',
      targetDate: '2025-05-10',
      responsible: 'Bruna Almeida'
    },
    {
      name: 'Hardware Compatibility Test',
      assignedBy: 'Beatriz Rocha',
      openDate: '2025-04-12',
      targetDate: '2025-05-15',
      responsible: 'Felipe Martins'
    },
    {
      name: 'Performance Benchmarking',
      assignedBy: 'Pedro Sant Ana',
      openDate: '2025-04-15',
      targetDate: '2025-05-20',
      responsible: 'Carlos Pereira'
    }
  ];

  spctList = [
    {
      name: 'System Pressure Test',
      assignedBy: 'Vera Lemos',
      openDate: '2025-04-04',
      targetDate: '2025-04-17',
      responsible: 'André Peixoto'
    },
    {
      name: 'Temperature Calibration',
      assignedBy: 'Caio Cardoso',
      openDate: '2025-04-09',
      targetDate: '2025-04-21',
      responsible: 'Camila Amorim'
    },
    {
      name: 'Control Unit Validation',
      assignedBy: 'Patrícia Rezende',
      openDate: '2025-04-11',
      targetDate: '2025-04-23',
      responsible: 'Marcelo Teixeira'
    },
    {
      name: 'Voltage Regulation Test',
      assignedBy: 'Lucas Mendes',
      openDate: '2025-04-13',
      targetDate: '2025-04-25',
      responsible: 'Fernanda Alves'
    },
    {
      name: 'CAN Bus Signal Validation',
      assignedBy: 'Amanda Torres',
      openDate: '2025-04-14',
      targetDate: '2025-04-26',
      responsible: 'Daniela Ferreira'
    }
  ];  

  generalList = [
    {
      name: 'Monthly Team Meeting',
      assignedBy: 'Adriana Gomes',
      openDate: '2025-04-05',
      targetDate: '2025-04-10',
      responsible: 'Gustavo Andrade'
    },
    {
      name: 'Policy Update Review',
      assignedBy: 'Eduarda Lopes',
      openDate: '2025-04-06',
      targetDate: '2025-04-12',
      responsible: 'Sérgio Oliveira'
    },
    {
      name: 'Facility Maintenance',
      assignedBy: 'Bruno Pires',
      openDate: '2025-04-08',
      targetDate: '2025-04-14',
      responsible: 'Larissa Machado'
    },
    {
      name: 'Annual Compliance Training',
      assignedBy: 'Renato Silva',
      openDate: '2025-04-09',
      targetDate: '2025-04-15',
      responsible: 'Thiago Souza'
    },
    {
      name: 'New Employee Orientation',
      assignedBy: 'Marina Lima',
      openDate: '2025-04-10',
      targetDate: '2025-04-16',
      responsible: 'Pedro Sant Ana'
    }
  ];

  rowsPerPageValuesArray = [2, 4, 6];

  // Safety
  pageSafety = 1;
  rowsPerPageSafety = 2;

  // Quality
  pageQuality = 1;
  rowsPerPageQuality = 2;

  // Assembly
  pageAssembly = 1;
  rowsPerPageAssembly = 2;

  // Assembly
  pageLogistics = 1;
  rowsPerPageLogistics = 2;

  // Project
  pageProject = 1;
  rowsPerPageProject = 2;

  // Spct
  pageSpct = 1;
  rowsPerPageSpct = 2;

  // General
  pageGeneral = 1;
  rowsPerPageGeneral = 2;


  pagesSafetyList = Math.ceil(this.safetyList.length / this.rowsPerPageSafety);
  pagesQualityList = Math.ceil(this.qualityList.length / this.rowsPerPageQuality);
  pagesAssemblyList = Math.ceil(this.assemblyList.length / this.rowsPerPageAssembly);
  pagesLogisticsList = Math.ceil(this.logisticsList.length / this.rowsPerPageLogistics);
  pagesProjectList = Math.ceil(this.projectList.length / this.rowsPerPageProject);
  pagesSpctList = Math.ceil(this.spctList.length / this.rowsPerPageSpct);
  pagesGeneralList = Math.ceil(this.generalList.length / this.rowsPerPageGeneral);
  
  tableSafetyData = this.safetyList.slice(this.pageSafety, this.pageSafety + this.rowsPerPageSafety);
  tableQualityData = this.qualityList.slice(this.pageQuality, this.pageQuality + this.rowsPerPageQuality);
  tableAssemblyData = this.assemblyList.slice(this.pageAssembly, this.pageAssembly + this.rowsPerPageAssembly);
  tableLogisticsData = this.logisticsList.slice(this.pageLogistics, this.pageLogistics + this.rowsPerPageLogistics);
  tableProjectData = this.projectList.slice(this.pageProject, this.pageProject + this.rowsPerPageProject);
  tableSpctData = this.spctList.slice(this.pageSpct, this.pageSpct + this.rowsPerPageSpct);
  tableGeneralData = this.generalList.slice(this.pageGeneral, this.pageGeneral + this.rowsPerPageGeneral);

  constructor() { }

  ngAfterViewInit(): void {
    this.safetyListRef.connectedTo = [this.qualityListRef];
    this.qualityListRef.connectedTo = [this.safetyListRef, this.assemblyListRef];
    this.assemblyListRef.connectedTo = [this.qualityListRef, this.logisticsListRef];
    this.logisticsListRef.connectedTo = [this.assemblyListRef, this.projectListRef];
    this.projectListRef.connectedTo = [this.logisticsListRef, this.spctListRef];
    this.spctListRef.connectedTo = [this.projectListRef, this.generalListRef];
    this.generalListRef.connectedTo = [this.spctListRef]
  }

  drop(event: CdkDragDrop<any[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }

    this.updateTableSafety();
    this.updateTableQuality();
    this.updateTableAssembly();
    this.updateTableLogistics();
    this.updateTableProject();
    this.updateTableSpct();
    this.updateTableGeneral();
  }

  handlePaginationSafetyTable(event: any) {
    const { tableID, paginationValue, rowsPerPage } = event.detail;
    this.pageSafety = paginationValue;
    this.rowsPerPageSafety = rowsPerPage;

    this.updateTableSafety();
  }

  handlePaginationQualityTable(event: any) {
    const { tableID, paginationValue, rowsPerPage } = event.detail;
    this.pageQuality = paginationValue;
    this.rowsPerPageQuality = rowsPerPage;

    this.updateTableQuality();
  }

  handlePaginationAssemblyTable(event: any) {
    const { tableID, paginationValue, rowsPerPage } = event.detail;
    this.pageAssembly = paginationValue;
    this.rowsPerPageAssembly = rowsPerPage;

    this.updateTableAssembly();
  }

  handlePaginationLogisticsTable(event: any) {
    const { tableID, paginationValue, rowsPerPage } = event.detail;
    this.pageLogistics = paginationValue;
    this.rowsPerPageLogistics = rowsPerPage;

    this.updateTableLogistics();
  }

  handlePaginationProjectTable(event: any) {
    const { tableID, paginationValue, rowsPerPage } = event.detail;
    this.pageProject = paginationValue;
    this.rowsPerPageProject = rowsPerPage;

    this.updateTableProject();
  }

  handlePaginationSpctTable(event: any) {
    const { tableID, paginationValue, rowsPerPage } = event.detail;
    this.pageSpct = paginationValue;
    this.rowsPerPageSpct = rowsPerPage;

    this.updateTableSpct();
  }

  handlePaginationGeneralTable(event: any) {
    const { tableID, paginationValue, rowsPerPage } = event.detail;
    this.pageGeneral = paginationValue;
    this.rowsPerPageGeneral = rowsPerPage;

    this.updateTableGeneral();
  }

  updateTableSafety() {
    this.pagesSafetyList = Math.ceil(this.safetyList.length / this.rowsPerPageSafety);
    this.tableSafetyData = this.getPaginatedData(this.safetyList, this.pageSafety, this.rowsPerPageSafety);
  }
  
  updateTableQuality() {
    this.pagesQualityList = Math.ceil(this.qualityList.length / this.rowsPerPageQuality);
    this.tableQualityData = this.getPaginatedData(this.qualityList, this.pageQuality, this.rowsPerPageQuality);
  }
  
  updateTableAssembly() {
    this.pagesAssemblyList = Math.ceil(this.assemblyList.length / this.rowsPerPageAssembly);
    this.tableAssemblyData = this.getPaginatedData(this.assemblyList, this.pageAssembly, this.rowsPerPageAssembly);
  }

  updateTableLogistics() {
    this.pagesLogisticsList = Math.ceil(this.logisticsList.length / this.rowsPerPageLogistics);
    this.tableLogisticsData = this.getPaginatedData(this.logisticsList, this.pageLogistics, this.rowsPerPageLogistics);
  }

  updateTableProject() {
    this.pagesProjectList = Math.ceil(this.projectList.length / this.rowsPerPageProject);
    this.tableProjectData = this.getPaginatedData(this.projectList, this.pageProject, this.rowsPerPageProject);
  }

  updateTableSpct() {
    this.pagesSpctList = Math.ceil(this.spctList.length / this.rowsPerPageSpct);
    this.tableSpctData = this.getPaginatedData(this.spctList, this.pageSpct, this.rowsPerPageSpct);
  }

  updateTableGeneral() {
    this.pagesGeneralList = Math.ceil(this.generalList.length / this.rowsPerPageGeneral);
    this.tableGeneralData = this.getPaginatedData(this.generalList, this.pageGeneral, this.rowsPerPageGeneral);
  }

  getPaginatedData(list: any[], page: number, rowsPerPage: number) {
    const start = (page - 1) * rowsPerPage;
    const end = start + rowsPerPage;
    return list.slice(start, end);
  }

}
